"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfpProCustomerOrders = void 0;
const react_1 = __importStar(require("react"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_solid_svg_icons_2 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const SearchInput_1 = require("./SearchInput");
const DateFilterPicker_1 = require("./DateFilterPicker");
const customerAccountContext_1 = require("../../../../contexts/customerAccountContext");
const MfpProOrderRow_1 = require("./MfpProOrderRow");
const MfpProOrdersHeader_1 = require("./MfpProOrdersHeader");
const Pagination_1 = require("./Pagination");
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../../constants");
const currentWebsiteContext_1 = require("../../../../contexts/currentWebsiteContext");
const MfpProCustomerOrders = () => {
    const ORDERS_PER_PAGE = 15;
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const { currentWebsite } = (0, react_1.useContext)(currentWebsiteContext_1.CurrentWebsiteContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [filteredOrders, setFilteredOrders] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [orderNumberFilter, setOrderNumberFilter] = (0, react_1.useState)("");
    const [dateFilter, setDateFilter] = (0, react_1.useState)({
        from: `${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()} 00:00:00`,
        to: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:59:59`,
    });
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { orders } = customerAccountContext.actions;
    (0, react_1.useEffect)(() => {
        loadOrders(1);
    }, [dateFilter, orderNumberFilter]);
    const loadOrders = (page) => {
        setIsLoading(true);
        orderNumberFilter == "" ? getOrdersByDate(page) : getOrdersByOrdersId(page);
    };
    const getOrdersByDate = (page) => {
        orders
            .getOrdersByDate({
            fromDate: dateFilter.from,
            toDate: dateFilter.to,
            customerId: customerAccountContext.customerId,
            storeCode: `${currentWebsite}_${currentLocale.toLowerCase()}`,
            currentPage: page,
            pageSize: ORDERS_PER_PAGE,
        })
            .then((data) => {
            if (data === null || data === void 0 ? void 0 : data.orders) {
                setFilteredOrders(data.orders);
                setTotalCount(data.totalCount);
                setTotalCount(data.totalCount);
            }
        })
            .catch(() => { })
            .finally(() => setIsLoading(false));
    };
    const getOrdersByOrdersId = (page) => {
        let orderFilterTrimmed = orderNumberFilter;
        if (orderNumberFilter[0] == "#") {
            orderFilterTrimmed = orderNumberFilter.slice(1);
        }
        if (orderFilterTrimmed.length > 0) {
            orders
                .getOrdersById({
                orderId: orderFilterTrimmed,
                customerId: customerAccountContext.customerId,
                storeCode: `${currentWebsite}_${currentLocale.toLowerCase()}`,
                currentPage: page,
                pageSize: ORDERS_PER_PAGE,
            })
                .then((data) => {
                if (data === null || data === void 0 ? void 0 : data.orders) {
                    setFilteredOrders(data.orders);
                    setTotalCount(data.totalCount);
                }
            })
                .catch(() => { })
                .finally(() => setIsLoading(false));
        }
        else {
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-mfp-pro-orders-container" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-mfp-pro-orders-title" }, t("customerAccount.orders.sectionTitle")),
        react_1.default.createElement("div", { className: "boutik-customer-account-mfp-pro-orders-list-container" },
            react_1.default.createElement("div", { className: "boutik-customer-account-mfp-pro-orders-filters-container" },
                react_1.default.createElement(SearchInput_1.SearchInput, { onSearchChange: setOrderNumberFilter, placeholder: t("customerAccount.orders.searchInput") }),
                react_1.default.createElement(DateFilterPicker_1.DateFilterPicker, { onChangeDate: (from, to) => setDateFilter({ from: from, to: to }) })),
            isLoading ? (react_1.default.createElement("div", { className: "boutik-customer-account-mfp-prop-orders-spinner-container" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "boutik-customer-account-mfp-prop-orders-spinner", icon: pro_solid_svg_icons_1.faSpinnerThird, spin: true }))) : (react_1.default.createElement(react_1.default.Fragment, null, filteredOrders.length === 0 ? (react_1.default.createElement("span", { className: "boutik-customer-account-mfp-prop-orders-no-orders" }, t("customerAccount.orders.noOrder"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(MfpProOrdersHeader_1.MfpProOrdersHeader, null),
                filteredOrders.map((order, key) => (react_1.default.createElement(MfpProOrderRow_1.MfpProOrderRow, { key: key, order: order })))))))),
        filteredOrders.length > 0 && (react_1.default.createElement(Pagination_1.Pagination, { total: totalCount, quantityPerPage: ORDERS_PER_PAGE, onPageChange: loadOrders, singleArrow: pro_solid_svg_icons_1.faPlay, doubleArrow: pro_solid_svg_icons_2.faForward }))));
};
exports.MfpProCustomerOrders = MfpProCustomerOrders;
//# sourceMappingURL=MfpProCustomerOrders.js.map